import React from 'react'
import { Form, Input, Button } from 'antd'
import { FormComponentProps } from 'antd/lib/form'

interface ILoginFormProps extends FormComponentProps {
    loading: boolean
    onSuccess?: (username: string, password: string) => any
}

class LoginForm extends React.Component<ILoginFormProps, any> {
    public handleSubmit = (e: any) => {
        e.preventDefault()
        this.props.form.validateFields(async (err: any, values: any) => {
            if (!err) {
                const { onSuccess } = this.props
                if (onSuccess) {
                    onSuccess(values.username, values.password)
                }
            }
        })
    }
    public render() {
        const { loading } = this.props
        const { getFieldDecorator } = this.props.form
        return (
            <Form onSubmit={this.handleSubmit} className='login-form'>
                <Form.Item className='title'>
                    Login
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('username', {
                        rules: [{ required: true, message: 'Please input your username!' }],
                    })(<Input placeholder='Username' />)}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Please input your Password!' }],
                    })(<Input type='password' placeholder='Password' />)}
                </Form.Item>
                <Form.Item>
                    <Button
                        type='primary'
                        htmlType='submit'
                        className='login-form-button'
                        loading={loading}
                    >
                        Login
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

export default Form.create<ILoginFormProps>({ name: 'login' })(LoginForm)
